(function (nameSpace, $) {
	function MobileLoader () {
		this.cacheElements();
	};

	MobileLoader.fn = MobileLoader.prototype;

	MobileLoader.fn.cacheElements = function () {
		this.$el = $('#mobile-loader');
	};

	MobileLoader.fn.show = function () {
		this.disableSwipe();
		this.$el.show();
		return this;
	};

	MobileLoader.fn.hide = function () {
		this.enableSwipe();
		this.$el.hide();
		return this;
	};

	MobileLoader.fn.disableSwipe = function () {
		this.kill('swipe')
			.kill('swipeleft')
			.kill('swiperight');
	};

	MobileLoader.fn.enableSwipe = function () {
		this.$el.off('swipe')
			.off('swipeleft')
			.off('swiperight');
	};

	MobileLoader.fn.kill = function (eventName) {
		this.$el.on(eventName, $.proxy(function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
		}, this));
		return this;
	};

	nameSpace.MobileLoader = MobileLoader;
})(window, jQuery);